import React, { useEffect, useState } from 'react';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import { useNavigate } from 'react-router-dom';

const Cause = ({  handleChange, values, setAdvPostData, populationsDatas, AdvPostData, CauseDatas, reset, tabs, setTabs }) => {

    const navigate = useNavigate()

    const searchParams = new URLSearchParams(window.location.search);
    const advancedSearchMiniTab = searchParams.get('advancedSearchMiniTab');
    const advancedSearchUrlQuery = searchParams.get('AdvancedSearch');
    const miniTab = JSON.parse(decodeURIComponent(advancedSearchMiniTab))

    const viewTabs = (name) => {
        const existingMiniTab = searchParams.get('advancedSearchTab');
        const AdvancedTab = existingMiniTab ? `&advancedSearchTab=${encodeURIComponent(existingMiniTab)}` : '';
        const AdvancedSearchUrl = searchParams.get('AdvancedSearch');
        const AdvancedSearchUrlQuery = AdvancedSearchUrl ? `&AdvancedSearch=${encodeURIComponent(AdvancedSearchUrl)}` : '';
        if (miniTab?.[name]) {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: false }))}${AdvancedTab}${AdvancedSearchUrlQuery}`, { replace: true });
        } else {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: true }))}${AdvancedTab}${AdvancedSearchUrlQuery}`, { replace: true });
        }
    }

    useEffect(() => {
        if (advancedSearchMiniTab) {
            setTabs(miniTab)
        }
    }, [advancedSearchMiniTab])

    useEffect(() => {
        if (advancedSearchUrlQuery) {
            try {
                const parsedData = JSON.parse(decodeURIComponent(advancedSearchUrlQuery));
                // reCallApi(parsedData);
                setAdvPostData(parsedData);
            } catch (error) {
                console.error("Error parsing search query:", error);
            }
        }
    }, [advancedSearchUrlQuery]);

 
    return (

        <div>


            {/* Cause/Thematic Area Section */}
            < div className="p-[10px] rounded-xl mt-[20px] bg-[white]" >
                <div className="flex justify-between items-center">
                    <ParagraphComp text="Cause/ Thematic Area" className="text-[#004878]" />
                    <div
                        className="cursor-pointer"
                        onClick={() => viewTabs('Cause/ Thematic Area')}
                    >
                        <ArrowDropDownCircleIcon className="text-[30px] text-[#004878]" />
                    </div>
                </div>

                {
                    tabs?.['Cause/ Thematic Area'] && (
                        < div className="mt-[20px]">
                            <CustomSelection
                                onChange={handleChange}
                                value={values['cause_thematic_area']}
                                name="cause_thematic_area"
                                disabledFilter={true}
                                label="Select"
                                mappingKey='option'
                                options={CauseDatas?.['cause_thematic_list']}
                            />
                        </div>
                    )
                }
            </div >

            {/* Populations/Segments Served Section */}
            < div className="p-[10px] rounded-xl mt-[20px] bg-[white]" >
                <div className="flex justify-between items-center">
                    <ParagraphComp
                        text="Population Segments/ Entities"
                        className="text-[#004878]"
                    />
                    <div
                        className="cursor-pointer"
                        onClick={() => viewTabs('Populations/ Segments Served')}
                    >
                        <ArrowDropDownCircleIcon className="text-[30px] text-[#004878]" />
                    </div>
                </div>
                {
                    tabs?.['Populations/ Segments Served'] && (
                        <div className="mt-[20px]">
                            <CustomSelection
                                onChange={handleChange}
                                value={values['populations_segments_served']}
                                name="populations_segments_served"
                                disabledFilter={true}
                                label="select"
                                mappingKey='option'
                                options={populationsDatas?.['populaton_segments_list']}
                            />
                        </div>
                    )
                }
            </div >
            {/* <DisplayFormikValues /> */}
            {/* Submit Button */}

        </div>

    );
};

export default Cause;
